'use client'

import { TableSize } from '@/components/common/table-size'
import { useTranslations } from 'next-intl'
import { SizeItem } from '@/types/size'
import { useMemo } from 'react'
import { BODY_SIZE } from '../../../../../../lib/constants/size'

interface BodyInfoProps {
  sizeChart: string
}

export const BodyInfo = ({ sizeChart }: BodyInfoProps) => {
  const t = useTranslations('product_detail.size_chart')
  const tSizeChart = useTranslations()

  const bodyInfo = useMemo(() => {
    if (sizeChart === 'FEMALE_PANTS') {
      const newBodySize = JSON.parse(JSON.stringify(BODY_SIZE)) // Deep copy

      newBodySize.rows.push({
        name: 'product_detail.size_chart.constants.size_labels.reference_height',
        id: 5,
      })

      newBodySize.matrix.push(
        { rowId: 5, columnId: 1, value: '155-160' },
        { rowId: 5, columnId: 2, value: '160-165' },
        { rowId: 5, columnId: 3, value: '165-169' },
        { rowId: 5, columnId: 4, value: '169-172' },
        { rowId: 5, columnId: 5, value: '172-175' }
      )

      return newBodySize
    }

    return BODY_SIZE
  }, [sizeChart])

  return (
    <>
      <p className='mb-2 text-sm text-neutral-600'>
        {t('body_measurement_note')}
      </p>
      <TableSize
        rows={bodyInfo.rows.map((row: SizeItem) => ({
          ...row,
          name: tSizeChart(row.name),
        }))}
        columns={bodyInfo.columns}
        matrix={bodyInfo.matrix}
        colClassName='min-w-32 text-start'
      />
    </>
  )
}
